import React from "react";

/**
 * A link that the admin preview shows but does not let anyone follow (contract §10.11:
 * the booking link, the course link and the calendar file are inert in preview). There is
 * no learner behind a preview, so a learner endpoint or a booking would only fail. When
 * `disabled`, it renders as a span with `aria-disabled`, since an `<a>` cannot be disabled.
 *
 * @param {object} props
 * @param {string} props.href
 * @param {boolean} props.disabled
 * @param {string} props.testId
 * @param {string} props.className          the followable link's classes
 * @param {string} props.disabledClassName  the inert form's classes
 * @param {boolean} [props.download]        ask the browser to download the target
 */
export default function GatedLink({ href, disabled, testId, className, disabledClassName, download = false, children }) {
  if (disabled) {
    return <span data-testid={testId} aria-disabled="true" className={disabledClassName}>{children}</span>;
  }
  return <a href={href} data-testid={testId} className={className} download={download || undefined}>{children}</a>;
}
